import React, { Fragment, useEffect, useRef, useState } from 'react'
import cn from 'classnames';
import { Tab } from '@headlessui/react'
import { useSelector } from 'react-redux';
import { selectCurrent } from '../../../../redux/settings/selectors';
import _ from 'lodash';
import useWindowDimensions from '../../../../hooks/useWindowsDimensions';

export default function TabContainer({ tabItems, selectedIndex, onChange = (i: any) => { } }: any) {
  const [color, setColor] = useState('universal')
  const result = useSelector(selectCurrent)
  const { height, width } = useWindowDimensions();
  const { header, footer, visible, sidebar, theme, primary, secondary } = result
  const filteredTabData: any = _.filter(tabItems, ['isVisible', true])
  const tabListRef = useRef<HTMLDivElement>(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(true);

  const scrollTabs = (direction: "left" | "right") => {
    if (tabListRef.current) {
      const scrollAmount = 150;
      tabListRef.current.scrollBy({ left: direction === "left" ? -scrollAmount : scrollAmount, behavior: "smooth" });
    }
  };

  const checkScroll = () => {
    if (tabListRef.current) {
      const { scrollLeft, scrollWidth, clientWidth } = tabListRef.current;

      // Prevent showing the right button if there's no overflow
      const isScrollable = scrollWidth > clientWidth;

      setCanScrollLeft(isScrollable && scrollLeft > 0);
      setCanScrollRight(isScrollable && scrollLeft + clientWidth < scrollWidth - 1);
    }
  };

  useEffect(() => {
    checkScroll();
  }, []);

  return (
    <>
      {width && width < 720 ?
        <>
          {/* Start - Mobile View */}
          <div className="relative w-full px-0 py-0 bg-white">
            {/* Left Scroll Button */}
            {canScrollLeft && (
              <button className="absolute left-0 z-10 py-3">
                <svg onClick={() => scrollTabs("left")} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" color="#2e2e2e" fill="none">
                  <path d="M15 6C15 6 9.00001 10.4189 9 12C8.99999 13.5812 15 18 15 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </button>
            )}

            <Tab.Group onChange={onChange} selectedIndex={selectedIndex}>
              <div className='px-6'>
                <Tab.List
                  ref={tabListRef}
                  onScroll={checkScroll}
                  className="m-2 items-center flex flex-nowrap overflow-hidden scroll-smooth"
                >
                  {filteredTabData.map((tab: any) => (
                    <Tab as={Fragment} key={tab.id}>
                      {({ selected }) => (
                        <button className={`px-2 flex items-center ${tab.isVisible ? "visible" : "hidden"}`}>
                          <span
                            className={`py-1 text-sm transition duration-300 whitespace-nowrap
                      ${selected ? "border-b-2 border-b-primary font-semibold text-primary" : "text-primary text-opacity-70 font-medium border-b-2 border-transparent"}
                    `}
                          >
                            {tab.title}
                          </span>
                        </button>
                      )}
                    </Tab>
                  ))}
                </Tab.List>
              </div>

              <Tab.Panels>
                {filteredTabData.map((tab: any, idx: any) => (
                  <Tab.Panel key={idx}>
                    <div className="active">{tab.component}</div>
                  </Tab.Panel>
                ))}
              </Tab.Panels>
            </Tab.Group>

            {/* Right Scroll Button */}
            {canScrollRight && (
              <button className={`absolute right-0 top-0 z-10 py-3`} >
                <svg onClick={() => scrollTabs("right")} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" color="#2e2e2e" fill="none">
                  <path d="M9.00005 6C9.00005 6 15 10.4189 15 12C15 13.5812 9 18 9 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </button>
            )}

          </div>
          {/* End - Mobile View */}
        </> :
        <div className={` sm:px-0 bg-white w-full ${sidebar ? `max-w-[calc(100vw-20rem)]` : `max-w-[calc(100vw-2rem)]`}`}>
          <Tab.Group>
            <Tab.List className="mt-3 mx-2 flex flex-wrap border-b border-white-light dark:border-[#191e3a]">
              {filteredTabData.map((tab: any) => (
                <Tab as={Fragment} key={tab.id}>
                  {({ selected }) => (
                    <button
                      className={`${tab.isVisible ? 'visible' : 'hidden'}
                    ${selected
                          ? '!border-skin-primary !border-b-white text-skin-primary dark:!border-[#191e3a] dark:!border-b-black'
                          : ''
                        } p-3.5 py-2 -mb-[1px] flex items-center border border-transparent hover:text-danger !outline-none transition duration-300`}
                    >
                      {/* <svg>...</svg> */}
                      {tab.title}
                    </button>
                  )}
                </Tab>
              ))}
            </Tab.List>
            <Tab.Panels className=" mx-2">
              {filteredTabData.map((tab: any, idx: any) => (
                <Tab.Panel key={idx}>
                  <div className="active pt-2">{tab.component}</div>
                </Tab.Panel>
              ))}
            </Tab.Panels>
          </Tab.Group>
        </div>}
    </>

  )
}
